import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  state: {
    loadingConfirmation: false,
    logoProviderConfirmation: '',
    details: {
      scheduled: '',
      category: '',
      enterprise: ''
    }
  },
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/hotsite/confirmacao/index.js